import { createFileRoute } from "@tanstack/react-router";
import { AllocationsBanking } from "@/components/AllocationsBanking";

function RouteComponent() {
  return <AllocationsBanking />;
}

export const Route = createFileRoute("/_authenticated/allocations-banking/")({
  component: RouteComponent,
  staticData: { page: "banking" },
});
